


const SkeletonSchedule = () => {


    return (
        <>
        </>
    )
}


export default SkeletonSchedule